/* Please update below variables as per store theme */

/*
 * Set the Add to Cart Button Id Selector Here
 */
var artifiButtonAddToCart = 'button#AddToCart';

/*
 * Set the Span Selector having Add to Cart Button Text Here
 */
var artifiSpanAddToCartText = '#AddToCartText';

/*
 * Set the Id of Hidden Product Select Dropdown Here
 */
var artifiHiddenProductSelector = '#productSelect';

/*
 * Personali Button class
 */
var artifiPersonalizeButtonClass = "btn";

/*
 * Javascript to add artifi functionality to the shopify store
 */
var artifi_app_api_key = "d89267551e65a853ee95d62dbbd3069f";
var artifyUrl = 'https://shopify.artifi.net/';
var artifiCustomSessionId = '';
var artifiIsGuest = '';
var pdfApiPath = '/Designer/Asset/DownloadOutputFiles';
var xmlApiPath = '/Designer/Services/GetOrderDetailXml';
/*
 * Function to get request parameters
 */
function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/* 
 * Function to open personalization Iframe
 */
var hasExecuted = 0;
var getArtifiSku = 0;
function openPersonalizeIframe(extraQueryString ) {
    var variant_id = getParameterByName('id');
    if (getArtifiSku === 0 && website_id !== 14) {

        jQuery.ajax({url: artifyUrl + 'getProductSkus.php?website_id=' + website_id + '&variant_id=' + variant_id, complete: function (result) {
                var variantObj = JSON.parse(result.responseText);
                jQuery.each(variantObj, function (i, val) {
                    jQuery('body').append('<input type = "hidden" name = "artifi_sku_'+val.artifi_sku+'" value = "'+val.variant_id+'">');
                });
            }});
        getArtifiSku = 1;
    }

    if (typeof Artifi === 'undefined' || Artifi === null || hasExecuted == 1) {
        return;
    }

    artifiCustomSessionId = jQuery('#artifiUserId').val();
    artifiIsGuest = 'false';
    if (artifiCustomSessionId === '') {
        artifiCustomSessionId = getArtifiCustomSessionId();
        artifiIsGuest = 'true';
    }


    var artifiUrl = artifyUrl + 'index.php';
    var product_id = getParameterByName('id');
    var artifiProductSku = getParameterByName('artifiProductSku');

    if (artifiProductSku !== "undefined" && artifiProductSku !== '' && artifiProductSku !== null) {
        product_id = artifiProductSku;
    }

    var quantity = getParameterByName('quantity');
    var designId = getParameterByName('design_id');
    var issimple = getParameterByName('issimple');
    var editMode = getParameterByName('mode');
    var guestinquote = getParameterByName('guestinquote');
if (typeof extraQueryString === "undefined" && extraQueryString === '' && extraQueryString === null) {
      extraQueryString   = '';
    }
    var childSku = '';
    if (issimple === '0') {
        childSku = product_id;

        var artifiVariantSku = getParameterByName('artifiVariantSku');
        if (artifiVariantSku !== "undefined" && artifiVariantSku !== '' && artifiVariantSku !== null) {
            childSku = artifiVariantSku;
        }
    }
    hasExecuted = 1;
    if (editMode === 'reorder') {
        Artifi.Initialize({productCode: product_id,
            websiteId: website_id,
            userId: jQuery('#artifiUserId').val(),
            divId: 'artifiIframeContainer',
            webApiclientKey: webapi_client_key,
            appMode: "reorder",
            isGuest: artifiIsGuest,
            width: '100%',
            height: '100%',
            designId: designId,
            sku: childSku,
            extraQueryString: extraQueryString,
            cartQueryString: ''});
    } else {
        if (designId && (jQuery('#artifiUserId').val() === '' || guestinquote === '1')) { // Case :: Edit
            jQuery.get('/cart.js').complete(function (data) {
                var responseObject = JSON.parse(data.responseText);
                Artifi.Initialize({productCode: product_id,
                    websiteId: website_id,
                    userId: responseObject.token,
                    divId: 'artifiIframeContainer',
                    webApiclientKey: webapi_client_key,
                    isGuest: artifiIsGuest,
                    width: '100%',
                    height: '100%',
                    designId: designId,
                    sku: childSku,
                    extraQueryString:extraQueryString,
                    cartQueryString: ''});
            });
        } else { // Case :: Add
            Artifi.Initialize({productCode: product_id,
                websiteId: website_id,
                userId: artifiCustomSessionId,
                divId: 'artifiIframeContainer',
                webApiclientKey: webapi_client_key,
                isGuest: artifiIsGuest,
                width: '100%',
                height: '100%',
                designId: designId,
                sku: childSku,
                extraQueryString: extraQueryString,
                cartQueryString: ''});
        }
    }
}


/*
 * Function called on Add to cart
 */
function receiveMessage(event)
{
    var eventdata = JSON.parse(event.data);
    var guestinquote = getParameterByName('guestinquote');
    if (typeof Artifi.isValidArtifiDomain === "function") {
        if (!Artifi.isValidArtifiDomain(event.origin)) {
            return false;
        }
    }

    if (eventdata.action === "add-to-cart") {
        jQuery('.artifi-loader').show();
        //Add the product to cart now
        var quantity = getParameterByName('quantity');
        var lineItemId = getParameterByName('line_item_id');
        var varient_id = getParameterByName('id');
        var designId = getParameterByName('design_id');
        var artifiMode = getParameterByName('mode');
        var thumbImages = eventdata.data.savedDesigns;
        var thumbImagesArray = thumbImages.toString().split(',');
        var baseUrl = window.location.protocol + "//" + window.location.host;
        var artifiPdfUrl = artifi_integration_url + 
                pdfApiPath + 
                '?customizedProductId=' + 
                eventdata.data.custmizeProductId;
        
        var artifiXmlUrl = artifi_integration_url + 
                xmlApiPath + 
                '?customizedProductId=' + 
                eventdata.data.custmizeProductId + 
                '&websiteId=' +
                website_id +
                '&webApiClientKey=' + 
                webapi_client_key;

        baseUrl = baseUrl.replace("/pages/personalize", "");
        var previewLinkUrl = baseUrl + '/admin/apps/' +
                artifi_app_api_key + '?designid=' +
                eventdata.data.custmizeProductId +
                '&productcode=' + eventdata.data.productCode;

        var previewUrlProprtyName = '_Artifi Preview';
        var pdfUrlProprtyName = '_Artifi Design PDF';
        var xmlUrlProprtyName = '_Artifi Design XML';

        // Get Artifi Sku's
        var artifiVariantSku = getParameterByName('artifiVariantSku');
        if (artifiVariantSku === "undefined") {
            artifiVariantSku = '';
        }

        var artifiProductSku = getParameterByName('artifiProductSku');
        if (artifiProductSku === "undefined") {
            artifiProductSku = '';
        }

        var propertiesObj = {
            _ArtifiDesignId: eventdata.data.custmizeProductId,
            _ArtifiPersonalizedImageThumb: thumbImagesArray[0],
            _ArtifiUserIdInQuote: jQuery('#artifiUserId').val(),
            _ArtifiProduct: eventdata.data.productCode,
            _ArtifiVariant: eventdata.data.sku
        };

        propertiesObj[previewUrlProprtyName] = previewLinkUrl;

        if (save_pdf_link === '1') {
            propertiesObj[pdfUrlProprtyName] = artifiPdfUrl;
        }

        if (save_xml_link === '1') {
            propertiesObj[xmlUrlProprtyName] = artifiXmlUrl;
        }

        // Save Text And Images Data
        var customizedDataArray = getArtifiCustomizedData(eventdata.data.customizedData);

        // Get the Added Product Variant_id
        if( artifiProductSku == '' ) {
            varient_id = eventdata.data.sku;
        }
        if (eventdata.data.productCode !== eventdata.data.sku && website_id !== 14) {
            var inputName = 'artifi_sku_' + eventdata.data.sku;
            var mapped_variant_id = jQuery("input[name = '"+inputName+"']").val();
            if( mapped_variant_id !== '' && mapped_variant_id !== null && typeof mapped_variant_id !== 'undefined' ) {
                varient_id = mapped_variant_id;
            }  
        }

        jQuery.extend(propertiesObj, customizedDataArray);
        var addPrd = function () {
            jQuery.post('/cart/add.js', {
                quantity: quantity,
                id: varient_id,
                properties: propertiesObj
            }).complete(function (cart) {
                jQuery.get('/cart.js').complete(function (data) {
                    var responseObject = JSON.parse(data.responseText);
                    var updatedUserId = jQuery('#artifiUserId').val();
                    if (updatedUserId === '') {
                        updatedUserId = responseObject.token;
                    }
                    if ((artifiCustomSessionId.toString() !== updatedUserId.toString())
                            ||
                            (
                                    artifiCustomSessionId.toString() === updatedUserId.toString()
                                    &&
                                    guestinquote === "1"
                                    )

                            ) {
                        if (
                                artifiCustomSessionId.toString() === updatedUserId.toString()
                                &&
                                guestinquote === "1"
                                ) {
                            artifiCustomSessionId = responseObject.token;
                        }

                        jQuery(document).ready(function () {
                            Artifi.UpdateUserId({newUserId: updatedUserId,
                                oldUserId: artifiCustomSessionId,
                                IsGuest: artifiIsGuest,
                                websiteId: website_id,
                                webApiClientKey: webapi_client_key,
                                successCallback: function () {
                                    window.location.href = '/cart';
                                },
                                errorCallback: function () {
                                    window.location.href = '/cart';
                                }
                            });
                        });
                    } else {
                        window.location.href = '/cart';
                    }
                });
            });
        };

        if (typeof lineItemId !== 'undefined' && lineItemId != null) {
            jQuery.post('/cart/change.js', {quantity: 0, line: lineItemId}).complete(function (data) {
                addPrd();
            });
        } else {
            addPrd();
        }

    }
}


if (window.addEventListener) {
    addEventListener("message", receiveMessage, false);
} else {
    attachEvent("onmessage", receiveMessage);
}

/*
 * Function to open Preview image popup
 */
function openArtifiPreviewPopup(productCode, userId, isGuest, designId, variantsCount, userIdInQuote, artifiProductSku, atifiVariantSku) {
    if (isGuest === '') {
        isGuest = 'true';
    }
    var issimple = 1;
    if (variantsCount > 1) {
        issimple = 0;
    }
    var childSku = '';
    if (issimple === 0) {
        childSku = productCode;
    }
    // Set Custom Product Codes if available
    if (artifiProductSku !== '') {
        productCode = artifiProductSku;
    }
    if (atifiVariantSku !== '') {
        childSku = atifiVariantSku;
    }
    if( issimple === 1) {
        childSku = '';
    }
    
    if (userId === '' || userIdInQuote == '') {
        jQuery.get('/cart.js').complete(function (data) {
            var responseObject = JSON.parse(data.responseText);
            userId = responseObject.token;
            Artifi.PreviewPopUp(
                    {productCode: productCode,
                        websiteId: website_id,
                        userId: userId,
                        isGuest: isGuest,
                        width: 800,
                        height: 600,
                        designId: designId,
                        sku: childSku,
                        webApiclientKey: webapi_client_key,
                        extraQueryString: '',
                        cartQueryString: ''
                    }
            );
        });
    } else {
        Artifi.PreviewPopUp(
                {productCode: productCode,
                    websiteId: website_id,
                    userId: userId,
                    isGuest: isGuest,
                    width: 800,
                    height: 600,
                    designId: designId,
                    sku: childSku,
                    webApiclientKey: webapi_client_key,
                    extraQueryString: '',
                    cartQueryString: ''
                }
        );
    }
}

/*
 * Funtion to open Edit Design Page
 */
function artifiEditItem(productId, designId, personalizeId, variantsCount, reorder, quantity, line_item_id, userIdInQuote, artifiProductSku, atifiVariantSku) {
    var issimple = 1;
    if (variantsCount > 1) {
        issimple = 0;
    }
    var guestinquote = '0';
    if (userIdInQuote === '') {
        guestinquote = '1';
    }

    var url = '/pages/Personalize?id=' + productId +
            '&design_id=' + designId +
            '&personalize_id=' + personalizeId +
            '&issimple=' + issimple +
            '&line_item_id=' + line_item_id +
            '&quantity=' + quantity +
            '&guestinquote=' + guestinquote;

    if (artifiProductSku !== '' && artifiProductSku !== 'undefined') {
        url += '&artifiProductSku=' + artifiProductSku;
    }

    if (atifiVariantSku !== '' && atifiVariantSku !== 'undefined') {
        url += '&artifiVariantSku=' + atifiVariantSku;
    }

    if (reorder === 'reorder') {
        url += '&mode=reorder';
    }
    window.location.href = url;
}

/*
 * Generate GUID to store as checkout session identifier
 * before adding any item to the chart. It will not be required 
 * when atleast one item is added to the cart
 */
function getArtifiCustomSessionId() {
    var currentTimestamp = Math.floor(Date.now() / 1000);
    var randomNumber = getRandomArbitrary(1000, 100000);
    var guid = '';
    guid += currentTimestamp;
    guid += randomNumber;
    return guid;
}

/*
 * Function returns a random number between min (inclusive) and max (exclusive)
 */
function getRandomArbitrary(min, max) {
    return Math.round(Math.random() * (max - min) + min);
}
/*
 * Get Customized Data as object
 */

function getArtifiCustomizedData(customizedDataObj) {

    var view_name = '';
    var edit_type = '';
    var key_name = '';
    var widget_key = '';
    var propertiesObj = {};
    var objectkey = '';
    var imageUrl = '';
    for (var key in customizedDataObj) {
        view_name = key;
        if ('text' in customizedDataObj[key]) {
            for (var key_1 in customizedDataObj[key].text) {
                edit_type = 'text';
                key_name = key_1;
                widget_key = customizedDataObj[key].text[key_1].widgetKey;

                objectkey = '_ Artifi Customizations : ' + view_name + ' ' + edit_type + ' ' + key_name;
                if (widget_key !== '') {
                    objectkey += ' ( ' + widget_key + ' )';
                }
                propertiesObj[objectkey] = customizedDataObj[key].text[key_1].text;
                widget_key = '';
            }
        }
        if ('image' in customizedDataObj[key]) {
            for (var key_2 in customizedDataObj[key].image) {
                edit_type = 'image';
                key_name = key_2;
                widget_key = customizedDataObj[key].image[key_2].widgetKey;
                objectkey = '_ Artifi Customizations : ' + view_name + ' ' + edit_type + ' ' + key_name;
                if (widget_key !== '') {
                    objectkey += ' ( ' + widget_key + ' )';
                }
                imageUrl = customizedDataObj[key].image[key_2].src;
                if (imageUrl.indexOf('http:') === -1 && imageUrl.indexOf('https:') === -1) {
                    imageUrl = 'https:' + imageUrl;
                }
                propertiesObj[objectkey] = imageUrl;
                widget_key = '';
            }
        }
    }
    return propertiesObj;
}



/*
 * Loads JQuery if not present
 * @param {type} url
 * @param {type} callback
 * @returns {undefined}
 */
function loadScript(url, callback) {

    var script = document.createElement("script")
    script.type = "text/javascript";

    if (script.readyState) {  //IE
        script.onreadystatechange = function () {
            if (script.readyState == "loaded" ||
                    script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function () {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}

var artifiAppJavaScript = function ($) {
    $(document).ready(
            function () {
                var hideAddToCart = 0;
                /*
                 * Set Cart Button Text
                 */
                if ($(artifiButtonAddToCart).length) {
                    $(artifiSpanAddToCartText).text(text_cart_button);
                }
                /*
                 * Open the Personalzation Iframe
                 */
                if ($('#artifiIframeContainer').length) {
                    setInterval(function () {
                        if (typeof openPersonalizeIframe === "function") {
                            openPersonalizeIframe();
                        }
                    }, 1000);
                }
                /*
                 * Check if artifi product - and add personalize button
                 */
                if ($(artifiButtonAddToCart).length && $('#isArtifiProduct').length && $('#isArtifiProduct').val()) {
                    var myInterval = setInterval(
                            function () {
                                if (typeof artifi_app_api_key === "undefined") {
                                    // do nothing
                                } else {
                                    var issimple = '1';
                                    if ($('select' + artifiHiddenProductSelector + ' option').length > 1) {
                                        issimple = '0';
                                    }
                                    jQuery(artifiButtonAddToCart).after('<input type="hidden" name="artifiSku" id="artifiSku" value="' + meta.product.variants[0].sku + '"' +
                                            '/><input type="hidden" name="issimple" id="issimple" value="' + issimple + '"><button class="' + artifiPersonalizeButtonClass + '" id="artifiPersonalize" name="personalize" type="button">' +
                                            '<span id="artifiPersonalizeText">' + text_personalize_button + '</span>' +
                                            '</button>'
                                            );
                                    if ($('#isPersonalizationOptional').val() === '0') {
                                        hideAddToCart = 1;
                                        $(artifiButtonAddToCart).hide();
                                    }
                                    /*
                                     * Personalize button click event
                                     * Function to open new added personalization page by App installer
                                     */
                                    jQuery('button#artifiPersonalize').on('click', function (e) {
                                        e.preventDefault();
                                        var selectedSku = jQuery(artifiHiddenProductSelector + ' option:selected').attr('value');
                                        jQuery('#artifiSku').val(selectedSku);
                                        var idVal = $(artifiHiddenProductSelector).val();
                                        var artifiSkuVal = jQuery('#artifiSku').val();
                                        var isSimpleVal = jQuery('#issimple').val();
                                        var personalize_url = '/pages/Personalize?id=' + idVal + '&artifiSku=' + artifiSkuVal + '&issimple=' + isSimpleVal;

                                        // Get Prod Artifi Sku
                                        var artifiProductSku = jQuery('#artifiSku_0').val();
                                        if (artifiProductSku !== '') {
                                            personalize_url += '&artifiProductSku=' + artifiProductSku;

                                        }

                                        // Get Variant Artifi Sku
                                        var artifiVariantSku = jQuery('#artifiSku_' + selectedSku).val();
                                        if (artifiVariantSku !== '') {
                                            personalize_url += '&artifiVariantSku=' + artifiVariantSku;
                                        }
                                        window.location.href = personalize_url;
                                    });


                                    clearInterval(myInterval);
                                }
                            }, 1000
                            );
                }
                if (hideAddToCart === 0) {
                    jQuery(artifiButtonAddToCart).show();
                }
            }
    );
};

if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
    loadScript('//ajax.googleapis.com/ajax/libs/jquery/3.1.1/jquery.min.js', function () {
        jQuery311 = jQuery.noConflict(true);
        artifiAppJavaScript(jQuery311);
    });
} else {
    artifiAppJavaScript(jQuery);
}
